import { CardListsActionlessActions } from './actionless'
import { FetchingMoreActionType, FetchingMoreErrorActionType, FetchingMoreSuccessActionType } from './fetchMore'
import { fetchMore } from './fetchMore'
import { groupBy } from './groupBy'
import { sortBy } from './sortBy'
import { submitFilters } from './submitFilters'
import { SubmitFiltersActionType } from './submitFilters'

export type CardListsActions =
  | CardListsActionlessActions
  | FetchingMoreActionType
  | FetchingMoreErrorActionType
  | FetchingMoreSuccessActionType
  | SubmitFiltersActionType

export { fetchMore, groupBy, sortBy, submitFilters }
